const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLingerie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.981 511.981",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 240.82,
    y: 181.29,
    style: {
      fill: "#967ADA"
    },
    width: 28.562,
    height: 21.327
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#967ADA"
    },
    d: "M106.66,0c-5.89,0-10.664,4.765-10.664,10.656v92.215h21.335V10.656 C117.332,4.765,112.551,0,106.66,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#967ADA"
    },
    d: "M405.33,0c-5.906,0-10.688,4.765-10.688,10.656v92.215h21.344V10.656 C415.986,4.765,411.205,0,405.33,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AC92EA"
    },
    d: "M415.017,341.362c-1.031,0.094-104.372,9.438-159.026,10.609 c-54.63-1.172-157.986-10.516-159.025-10.609L85.334,340.3v42.842l6.679,2.688c1.164,0.469,116.66,47.702,132.237,117.793 l1.852,8.358h59.78l1.858-8.358c15.531-69.966,131.059-117.324,132.23-117.793l6.671-2.688V340.3L415.017,341.362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AC92EA"
    },
    d: "M117.379,95.965c-15.492,0-28.483,5.375-37.584,15.562c-9.695,10.843-14.984,27.03-15.718,48.107 c-0.914,26.171,5.898,46.983,20.241,61.841c15.062,15.593,37.983,23.828,66.303,23.828c0.008,0,0,0,0.008,0 c20.717,0,43.982-4.609,63.818-12.64c12.21-4.938,33.452-15.468,38.592-30.405c2.93-8.469,0.047-18.64-8.82-31.078 C222.383,140.51,162.112,95.965,117.379,95.965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AC92EA"
    },
    d: "M447.905,159.634c-0.734-21.077-6.03-37.264-15.732-48.107 c-9.094-10.188-22.093-15.562-37.593-15.562c-44.748,0-105.027,44.561-126.862,75.231c-8.852,12.438-11.734,22.609-8.805,31.046 c5.156,14.953,26.406,25.483,38.608,30.42c19.843,8.031,43.092,12.64,63.825,12.64c28.327,0,51.233-8.234,66.295-23.828 C442,206.617,448.811,185.821,447.905,159.634z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLingerie);
export default __webpack_public_path__ + "static/media/lingerie.a9f9c005b225d71972efaeeace8be148.svg";
export { ForwardRef as ReactComponent };